import React, { useState, useEffect } from "react";
import dynamic from "next/dynamic";
import { useDispatch } from "react-redux";
import store from "@/redux/store";

const MetaTags = dynamic(() => import("@/common/MetaTags"));
const InfoSection = dynamic(() => import("@/common/InfoSection"));

const TwoColumnIconBoxCardWithImage = dynamic(() =>
  import("@/components/common/TwoColumnIconBoxCardWithImage")
);
const TwoColumnGradientCard = dynamic(() =>
  import("@/components/common/TwoColumnGradientCard")
);
const TwoColumnMapWithSidebarInfo = dynamic(() =>
  import("@/components/common/TwoColumnMapWithSidebarInfo")
);

const Search = dynamic(() => import("@/components/search/search"));

import { fetchSediPagesData } from "@/redux/actions/sediPageActions";
import {
  fetchLabelsAndConfigData,
  setLabelsConfigsData,
} from "@/redux/actions/labelsAndConfigActions";

// Import graphQL query variable
import { LABEL_AND_CONFIG_QUERY } from "@/graphql/settingsQuery";
import { SEDIPAGE_QUERY } from "@/graphql/sediPageQuery";

const Locations = (props) => {
  const { pageData, labelsConfigData, sediPageData } = props;

  const dispatch = useDispatch();

  const [labelsList, setLabelsList] = useState();
  const [siteConfig, setSiteConfig] = useState();
  const [searchKeyword, setSearchKeyword] = useState("");

  useEffect(() => {
    // Set labelsList local state while changed on redux store data
    dispatch(setLabelsConfigsData(labelsConfigData));
    setLabelsList(labelsConfigData?.labelsList);
    setSiteConfig(labelsConfigData?.siteConfig);
  }, [dispatch, labelsConfigData]);

  return (
    <>
      <MetaTags
        metaTags={sediPageData?.premisesList?._seoMetaTags}
        seoData={sediPageData?.premisesList?.seo}
        noFollow={sediPageData?.premisesList?.nofollow}
        noIndex={sediPageData?.premisesList?.noindex}
      />
      <InfoSection title={sediPageData?.premisesList?.subtitle} />
      <Search searchChanged={(value) => setSearchKeyword(value)} />
      <section className="md:pb-10">
        <TwoColumnMapWithSidebarInfo
          premisesData={sediPageData?.premisesList?.map}
          iconData={sediPageData?.premisesList?.premisesIcon}
          labelsList={labelsList}
          siteConfig={siteConfig}
          searchKeyword={searchKeyword}
          onlinePremise={sediPageData?.onlinePremise}
          sediPage={true}
        />
      </section>
      <section className="pt-10">
        <div className="container">
          <TwoColumnIconBoxCardWithImage
            pageBoxesList={pageData?.sediPageData?.premisesList?.pageBoxesList}
            labelsList={labelsList}
          />
        </div>
      </section>
      <TwoColumnGradientCard
        standardPage={sediPageData?.standardPage}
        externalLinkPage={sediPageData?.externalLinkPage}
        labelsList={labelsList}
      />
    </>
  );
};

export default Locations;

export async function getStaticProps({ preview = false, locale = "en" }) {
  let requestParams = SEDIPAGE_QUERY?.replace(/\lang/g, locale);

  const sediResponse = await store.dispatch(
    fetchSediPagesData(requestParams, preview)
  );

  const labelsConfigData = await store.dispatch(
    fetchLabelsAndConfigData(LABEL_AND_CONFIG_QUERY, preview, { lang: locale })
  );

  return {
    props: {
      preview,
      sediPageData: sediResponse,
      labelsConfigData: labelsConfigData || {},
      pageData: { sediPageData: sediResponse },
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: [{ params: { slug: "scuole" } }],
    fallback: true,
  };
}
